let eOm = [
  {
    path: '/eye_classList',
    name: '科室列表',
    component: () => import('@/pages/eyeOrMouse/index.vue')
  },
  {
    path: '/eye_classList_',
    name: '科室列表',
    component: () => import('@/pages/eyeOrMouse/blank.vue')
  },
  {
    path: '/imgShow',
    name: '科室列表',
    component: () => import('@/pages/eyeOrMouse/imgShow.vue')
  },
]

export default eOm
